

















































import {
  computed,
  defineComponent,
  getCurrentInstance,
  provide,
  onMounted,
  watch
} from "@vue/composition-api";
import AppHeader from "@/components/Organisms/AppHeader";
import LoggedInByProxyBar from "@/components/Organisms/LoggedInByProxyBar/index.vue";
import ScoutAgentBar from "@/components/Organisms/ScoutAgentBar/index.vue";
import AppContent from "@/components/Organisms/AppContent";
import NavigationDrawer from "@/components/Organisms/NavigationDrawer/NavigationDrawer.vue";
import GlobalMessageBar from "@/components/Organisms/GlobalMessageBar/index.vue";
import AlertView from "@/components/Molecules/AlertView/index.vue";
import TermsPopup from "@/components/Molecules/TermsPopup/index.vue";
import ErrorForbidden from "@/components/Pages/Error/Forbidden";
import ErrorNotFound from "@/components/Pages/Error/NotFound";
import SvgVisibility from "@/components/Molecules/SvgVisibility/index.vue";
import { axiosInstance } from "@/api";
import {
  NetworkError,
  InternalServerError,
  UnauthorizedError,
  ForbiddenError,
  NotFoundError,
  UnprocessableEntityError
} from "@/api/types";
import {
  GLOBAL_MESSAGE,
  useGlobalMessage
} from "./helpers/hooks/useGlobalMessage";
import { TERMS_POPUP, useTermsPopup } from "./helpers/hooks/useTermsPopup";
import { useGlobalState } from "@/helpers/hooks/useGlobalState";
import { removeSentryUser } from "@/helpers/sentry-helper";
import { useRouter } from "@/router";
// import { useRoute, useRouter } from "@/router"; // TODO: vue-router4移行時に書き換える
import { useStore } from "@/store";
import { clearSearchOptionInLocalStorage } from "@/components/Pages/Scout/Candidates/methods";
import {
  clearMenuTypeInLocalStorage,
  restoreMenuTypeFromLocalStorage,
  saveMenuTypeToLocalStorage
} from "@/helpers/menu-type-helper";
import { MenuType } from "@/store/domains/user/types";
import { hasScoutAgentContract } from "@/helpers/contract-helper";

export default defineComponent({
  components: {
    AlertView,
    TermsPopup,
    SvgVisibility,
    AppHeader,
    LoggedInByProxyBar,
    ScoutAgentBar,
    AppContent,
    NavigationDrawer,
    GlobalMessageBar,
    ErrorForbidden,
    ErrorNotFound
  },
  setup() {
    const instance = getCurrentInstance();
    // const route = useRoute(); // TODO: vue-router4移行時に書き換える
    const router = useRouter();
    const store = useStore();
    provide(GLOBAL_MESSAGE, useGlobalMessage());
    provide(TERMS_POPUP, useTermsPopup());
    const { isTermsPage, isTermsPopupVisible } = useGlobalState(TERMS_POPUP);

    const isLoggedIn = computed(() => {
      return store.getters["domains/user/isLoggedIn"];
    });

    const isShowNav = computed(() => {
      // TODO: vue-router3のhooksではrouteの変更を検知できないため、instance経由のrouteからアクセスする
      // vue-router4のhooksではrouteの変更を検知できるので、バージョンアップ時に書き換える。
      // https://router.vuejs.org/guide/advanced/composition-api.html#Accessing-the-Router-and-current-Route-inside-setup
      const route = instance?.proxy.$root.$route; // TODO: vue-router4移行時に削除してuseRouteで生成したrouteにアクセスさせる
      if (!route) return false;
      return isLoggedIn.value && !route.meta?.authPage;
    });

    const isUnlogginedUserAvailablePage = computed(() => {
      // TODO: vue-router3のhooksではrouteの変更を検知できないため、instance経由のrouteからアクセスする
      // vue-router4のhooksではrouteの変更を検知できるので、バージョンアップ時に書き換える。
      // https://router.vuejs.org/guide/advanced/composition-api.html#Accessing-the-Router-and-current-Route-inside-setup
      const route = instance?.proxy.$root.$route; // TODO: vue-router4移行時に削除してuseRouteで生成したrouteにアクセスさせる
      if (!route) return false;
      return route.meta?.authPage || isTermsPage.value;
    });

    const isScoutAgentMenuActive = computed<boolean>(() => {
      return store.getters["domains/user/isScoutAgentMenuActive"];
    });

    onMounted(() => {
      if (isLoggedIn.value) {
        restoreMenuTypeFromLocalStorage();
      }
    });

    const contractsLoaded = computed(() => {
      // いかなるパートナーでも「無料アカウント」をavailableContractsに持つため、availableContractsがあるかどうかで契約情報のロード完了を判定する
      // なお、availableContractsとexpiredContractsの更新タイミングは同じなので、expiredContractsは判定対象から除外する
      const availableContracts =
        store.state.domains.user.availableContracts ?? [];
      return availableContracts.length > 0;
    });

    watch(contractsLoaded, value => {
      if (!!value) {
        // エージェントメニューが選択されてない場合はなにもしない
        if (!isScoutAgentMenuActive.value) return;

        const availableContracts =
          store.state.domains.user.availableContracts ?? [];
        const expiredContracts =
          store.state.domains.user.expiredContracts ?? [];
        if (
          !hasScoutAgentContract(availableContracts.concat(expiredContracts))
        ) {
          // 画面でエージェントメニューが選択されている＆エージェント契約がない場合は異常なので、デフォルトメニューに戻してダッシュボードに遷移する
          // この状態は、複数アカウント操作していたり、例外的にエージェント契約自体を削除したりした場合に発生する
          saveMenuTypeToLocalStorage(MenuType.MENU_DEFAULT);
          store.commit("domains/user/changeMenuType", MenuType.MENU_DEFAULT);
          router.push({ name: "Home" }).catch(err => err); // NOTE: 重複遷移のエラーもみ消し
        }
      }
    });

    return {
      isTermsPopupVisible,
      isShowNav,
      isLoggedIn,
      isUnlogginedUserAvailablePage,
      isScoutAgentMenuActive,
      store,
      router
    };
  },
  data() {
    return {
      expand: true
    };
  },
  computed: {
    alertViewState() {
      // @ts-expect-error vue2のみbuild時に型エラーが発生するので、一時的にignoreする
      return this.store.state.common.alertView;
    },
    partnerUser() {
      // @ts-expect-error vue2のみbuild時に型エラーが発生するので、一時的にignoreする
      return this.store.state.domains.user.partnerUser;
    },
    hasForbiddenError() {
      // @ts-expect-error vue2のみbuild時に型エラーが発生するので、一時的にignoreする
      return this.store.getters["common/hasForbiddenError"];
    },
    hasNotFoundError() {
      // @ts-expect-error vue2のみbuild時に型エラーが発生するので、一時的にignoreする
      return this.store.getters["common/hasNotFoundError"];
    },
    hasUnagreedTermsError() {
      // @ts-expect-error vue2のみbuild時に型エラーが発生するので、一時的にignoreする
      return this.store.getters["common/hasUnagreedTermsError"];
    }
  },
  watch: {
    route() {
      this.store.commit("common/resetApiError");
      this.store.commit("common/resetGrpcError");
    }
  },
  created() {
    this.initializeApiErrorHandler();
  },
  methods: {
    initializeApiErrorHandler() {
      // NOTE: すべてのAPIで共通的に必要な処理を以下のコールバック関数で実行する
      axiosInstance.callbacks.apiErrors.push(async error => {
        if (error instanceof NetworkError) {
          this.store.commit("common/updateAlertView", {
            isVisible: true,
            title: "通信に失敗しました",
            message:
              "インターネットの接続を確認して再読み込みを実行してください"
          });
        } else if (error instanceof InternalServerError) {
          this.store.commit("common/updateAlertView", {
            isVisible: true,
            title: "通信に失敗しました",
            message:
              "サーバーでエラーが発生しました。しばらくしてからご確認ください"
          });
        } else if (error instanceof UnauthorizedError) {
          if (error.response.data.errors?.[0]?.disagreed) {
            this.store.commit("common/updateApiError", {
              code: error.response.status,
              message: "unagreedTerms"
            });
            return;
          }

          const isSignOut =
            error.response.config.url ===
            "/api/cloud/recruitment_planning/v1/partner_users/sign_out";
          if (this.partnerUser && !isSignOut) {
            // TODO: occid導入時にいい感じに共通化したい
            // c.f. https://github.com/OneCareerJP/cloud/blob/ccad61c33b06a93cb11e300a88618f21e4cbc95e/frontend/src/components/Organisms/AppHeader/index.ts#L118
            await this.store.dispatch("domains/user/signOut");
            await this.store.dispatch(
              "pages/performances/removePerformanceChartFilter"
            );
            removeSentryUser();
            clearSearchOptionInLocalStorage();
            clearMenuTypeInLocalStorage();
            this.$store.commit(
              "domains/user/changeMenuType",
              MenuType.MENU_DEFAULT
            );
            this.router
              .push({
                name: "SignIn",
                query: { isLoggedOut: "true" }
              })
              .catch(err => err);
            this.store.commit("common/updateAlertView", {
              isVisible: true,
              title: "認証に失敗しました",
              message: "再度ログインしてください"
            });
          }
        } else if (
          error instanceof NotFoundError ||
          error instanceof ForbiddenError ||
          error instanceof UnprocessableEntityError
        ) {
          this.store.commit("common/updateApiError", {
            code: error.response.status,
            message: "NotFound"
          });
        }
      });
    },
    handleAlertViewClose() {
      this.store.commit("common/updateAlertView", { isVisible: false });
    },
    // TODO: occid導入時にいい感じに共通化したい
    // c.f. https://github.com/OneCareerJP/cloud/blob/ccad61c33b06a93cb11e300a88618f21e4cbc95e/frontend/src/components/Organisms/AppHeader/index.ts#L118
    async signOut() {
      try {
        await this.store.dispatch("domains/user/signOut");
        await this.store.dispatch(
          "pages/performances/removePerformanceChartFilter"
        );
        removeSentryUser();
        clearSearchOptionInLocalStorage();
        clearMenuTypeInLocalStorage();
        this.$store.commit(
          "domains/user/changeMenuType",
          MenuType.MENU_DEFAULT
        );
        this.router
          .push({ name: "SignIn", query: { isLoggedOut: "true" } })
          .catch(err => err);
      } catch (error) {
        throw error;
      }
    }
  }
});
